import React, {Component} from 'react';
import {Table} from 'antd';
import {Link} from 'react-router';
import moment from 'moment';
import {connect} from 'react-redux';
import {queryIncuBusinessArchved} from '@api/incubator/business';

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataSource: {
        list: [],
        pagination: {},
      },
    };
  }

  componentDidMount() {
    const { contractTab, condition } = this.props;
    this.current = contractTab.archivedPage || 1;
    this.pageSize = contractTab.archivedPageSize || 10;
    this.condition = condition || {};
    this.getIncuBusinessArchved();
  }

  componentWillReceiveProps(nextProps) {
    if (
      Object.keys(nextProps.condition).some(key => nextProps.condition[key] !== this.condition[key])
    ) {
      this.condition = nextProps.condition;
      this.current = 1;
      this.getIncuBusinessArchved();
    }
  }

  getIncuBusinessArchved = () => {
    this.setState({
      loading: true,
    });
    const { pageSize } = this;
    queryIncuBusinessArchved({
      type: 'settled',
      limit: pageSize,
      start: this.current || 1,
      ...this.condition,
    }).then(res => {
      if (res.statusCode === 200) {
        this.props.onPageChange('settled', this.current, this.pageSize);
        this.setState({
          dataSource: {
            list: res.data,
            pagination: {
              pageSize,
              total: res.totalSize,
              current: this.current,
              showSizeChanger: true,
              showQuickJumper: true,
              pageSizeOptions: [10, 20, 50, 100],
            },
          },
          loading: false,
        });
      }
    });
  };

  onTableChange = pagination => {
    this.current = pagination.current;
    this.pageSize = pagination.pageSize;
    this.getIncuBusinessArchved();
  };

  columns = () => {
    const status = ['没有匹配', '完成匹配'];
    const termType = ['提前终止', '异常终止'];
    return [
      {
        title: '合同编号',
        dataIndex: 'no',
        width: 150,
        render: (text, record) => (
          <Link to={`/incubator/contract/${record.uuid}/info`}>{record.no}</Link>
        ),
      },
      {
        title: '企业名称',
        dataIndex: 'custom',
        width: 250,
      },
      {
        title: '合同周期',
        dataIndex: 'beginDate',
        width: 250,
        render: (text, record) =>
          record.beginDate && record.endDate ? (
            <span>
              {moment.unix(record.beginDate / 1000).format('YYYY-MM-DD')}至
              {moment.unix(record.endDate / 1000).format('YYYY-MM-DD')}
            </span>
          ) : null,
      },
      {
        title: '工位数',
        dataIndex: 'num',
        width: 100,
      },
      {
        title: '款项状态',
        dataIndex: 'status',
        width: 100,
        render: text => <span>{status[text]}</span>,
      },
      {
        title: '合同情况',
        dataIndex: 'termType',
        width: 150,
        render: text => <span>{termType[text] || '正常'}</span>,
      },
      {
        title: '合同归档时间',
        dataIndex: 'archiveDate',
        width: 200,
        render: (text, record) => {
          const diff = Math.floor((text - record.endDate) / 86400000);

          return (
            <div>
              {text ? moment.unix(text / 1000).format('YYYY-MM-DD') : ''}
              <p style={{ marginBottom: '0' }}>{diff < 0 ? `（提前${Math.abs(diff)}天）` : ''}</p>
              <p style={{ color: 'red', marginBottom: '0' }}>
                {diff > 0 ? `（逾期${Math.abs(diff)}天）` : ''}
              </p>
            </div>
          );
        },
      },
    ];
  };

  render() {
    const {
      dataSource: { list, pagination },
      loading,
    } = this.state;
    const expandedRowRender = record => <span>{record.termReason}</span>;
    return (
      <Table
        columns={this.columns()}
        dataSource={list}
        pagination={pagination}
        rowKey="uuid"
        onChange={this.onTableChange}
        scroll={{ x: 1150 }}
        loading={loading}
        expandedRowRender={expandedRowRender}
      />
    );
  }
}

export default connect(state => ({ contractTab: state.contract_tab }))(Index);



// WEBPACK FOOTER //
// ./src/components/incubator/contract/station/TableArchived.js